// extracted by mini-css-extract-plugin
module.exports = {"focused-label":"terms-styles-focused-label-ca1d5290","focusedLabel":"terms-styles-focused-label-ca1d5290","m10":"terms-styles-m10-d76de586"};